/* eslint-disable max-len */
// eslint-disable-next-line max-len
export const productsQuery = `query products($itemIds: [String!]!, $dataSource: String, $storeId: String) {
  products(itemIds: $itemIds, dataSource: $dataSource) {
    itemId
    identifiers {
      itemId
      isSuperSku
      parentId
      canonicalUrl
      brandName
      modelNumber
      productLabel
      productType
      storeSkuNumber,
      omsThdSku
    }
    badges {
      name
    }
    info {
      classNumber
      subClassNumber
      productDepartment
      quantityLimit
    }
    media {
      images {
        url
        type
        subType
        sizes
        altText
      }
    }
    pricing(storeId: $storeId) {
      conditionalPromotions {
        dates {
          start
          end
        }
        description {
          longDesc
          shortDesc
          __typename
        }
        eligibilityCriteria {
          itemGroup
          minPurchaseAmount
          minPurchaseQuantity
          omsSkus
          relatedSkusCount
          __typename
        }
        experienceTag
        reward {
          tiers {
            minPurchaseAmount
            minPurchaseQuantity
            rewardAmountPerItem
            rewardAmountPerOrder
            rewardFixedPrice
            rewardPercent
            __typename
          }
          __typename
        }
        subExperienceTag
        __typename
      }
      promotion {
        dates {
          end
          start
        }
        type
        description {
          shortDesc
          longDesc
        }
        dollarOff
        percentageOff
        savingsCenter
        savingsCenterPromos
        specialBuySavings
        specialBuyDollarOff
        specialBuyPercentageOff
        experienceTag
        subExperienceTag
        anchorItemList
        itemList
      }
      value
      alternatePriceDisplay
      alternate {
        bulk {
          pricePerUnit
          thresholdQuantity
          value
          __typename
        }
        unit {
          caseUnitOfMeasure
          unitsOriginalPrice
          unitsPerCase
          value
          __typename
        }
        __typename
      }
      original
      mapAboveOriginalPrice
      message
      preferredPriceFlag
      specialBuy
      unitOfMeasure
      __typename
    }
    specificationGroup {
      specifications {
        specName
        specValue
        __typename
      }
      specTitle
      __typename
    }
  }
}`;

export const searchFulfillmentQuery = `query searchModel($storeId: String, $zipCode: String, $skipInstallServices: Boolean = true, $startIndex: Int, $pageSize: Int, $orderBy: ProductSort, $filter: ProductFilter, $skipKPF: Boolean = true, $skipSpecificationGroup: Boolean = true, $skipSubscribeAndSave: Boolean = true, $keyword: String, $navParam: String, $storefilter: StoreFilter = ALL, $itemIds: [String], $channel: Channel = DESKTOP, $additionalSearchParams: AdditionalParams, $loyaltyMembershipInput: LoyaltyMembershipInput) {
  searchModel(keyword: $keyword, navParam: $navParam, storefilter: $storefilter, storeId: $storeId, itemIds: $itemIds, channel: $channel, additionalSearchParams: $additionalSearchParams, loyaltyMembershipInput: $loyaltyMembershipInput) {
    products(startIndex: $startIndex, pageSize: $pageSize, orderBy: $orderBy, filter: $filter) {
      itemId
      dataSources
      installServices(storeId: $storeId, zipCode: $zipCode)
        @skip(if: $skipInstallServices) {
        scheduleAMeasure @skip(if: $skipInstallServices)
        gccCarpetDesignAndOrderEligible @skip(if: $skipInstallServices)
        __typename
      }
      keyProductFeatures @skip(if: $skipKPF) {
        keyProductFeaturesItems {
          features {
            name
            refinementId
            refinementUrl
            value
            __typename
          }
          __typename
        }
        __typename
      }
      specificationGroup @skip(if: $skipSpecificationGroup) {
        specifications {
          specName
          specValue
          __typename
        }
        specTitle @skip(if: $skipSpecificationGroup)
        __typename
      }
      subscription @skip(if: $skipSubscribeAndSave) {
        defaultfrequency @skip(if: $skipSubscribeAndSave)
        discountPercentage @skip(if: $skipSubscribeAndSave)
        subscriptionEnabled @skip(if: $skipSubscribeAndSave)
        __typename
      }
      availabilityType {
        discontinued
        type
        buyable
        status
        __typename
      }
      fulfillment(storeId: $storeId, zipCode: $zipCode) {
        backordered
        backorderedShipDate
        bossExcludedShipStates
        excludedShipStates
        seasonStatusEligible
        fulfillmentOptions {
          type
          fulfillable
          services {
            type
            hasFreeShipping
            freeDeliveryThreshold
            locations {
              curbsidePickupFlag
              isBuyInStoreCheckNearBy
              distance
              inventory {
                isOutOfStock
                isInStock
                isLimitedQuantity
                isUnavailable
                quantity
                maxAllowedBopisQty
                minAllowedBopisQty
                __typename
              }
              isAnchor
              locationId
              storeName
              state
              type
              storePhone
              __typename
            }
            deliveryTimeline
            deliveryDates {
              startDate
              endDate
              __typename
            }
            deliveryCharge
            dynamicEta {
              hours
              minutes
              __typename
            }
            totalCharge
            __typename
          }
          __typename
        }
        anchorStoreStatus
        anchorStoreStatusType
        onlineStoreStatus
        onlineStoreStatusType
        __typename
      }
      dataSource
      __typename
    }
    __typename
  }
}`;

export const searchcollectionSkusQuery = `query searchModel(
  $storeId: String
  $zipCode: String
  $skipInstallServices: Boolean = true
  $startIndex: Int
  $pageSize: Int
  $orderBy: ProductSort
  $filter: ProductFilter
  $skipFavoriteCount: Boolean = false
  $keyword: String
  $navParam: String
  $storefilter: StoreFilter = ALL
  $itemIds: [String]
  $channel: Channel = DESKTOP
  $additionalSearchParams: AdditionalParams
  $loyaltyMembershipInput: LoyaltyMembershipInput
  $dataSource: String
  $skipDiscoveryZones: Boolean = true
  $skipBuyitagain: Boolean = true
  $skipKPF: Boolean = false
) {
  searchModel(
    keyword: $keyword
    navParam: $navParam
    storefilter: $storefilter
    storeId: $storeId
    itemIds: $itemIds
    channel: $channel
    additionalSearchParams: $additionalSearchParams
    loyaltyMembershipInput: $loyaltyMembershipInput
  ) {
    products(
      startIndex: $startIndex
      pageSize: $pageSize
      orderBy: $orderBy
      filter: $filter
    ) {
      identifiers {
        storeSkuNumber
        specialOrderSku
        canonicalUrl
        brandName
        itemId
        productLabel
        productType
        parentId
        modelNumber
        isSuperSku
        sampleId
        __typename
      }
      info {
        categoryHierarchy
        __typename
      }
      dataSource
      favoriteDetail @skip(if: $skipFavoriteCount) {
        count
        __typename
      }
      keyProductFeatures @skip(if: $skipKPF) {
        keyProductFeaturesItems {
          features {
            name refinementId refinementUrl value __typename
          }
          __typename
        } 
        __typename
      }
      specificationGroup {
        specifications {
          specName
          specValue
          __typename
        }
        specTitle
        __typename
      }
      bundleItems {
        id
        quantity
        __typename
      }
            pricing(storeId: $storeId) {
          alternatePriceDisplay
          alternate {
            bulk {
              pricePerUnit
              thresholdQuantity
              value
              __typename
            }
            unit {
              caseUnitOfMeasure
              unitsOriginalPrice
              unitsPerCase
              value
              __typename
            }
            __typename
          }
          original
          mapAboveOriginalPrice
          message
          preferredPriceFlag
          promotion {
            type
            description {
              shortDesc
              longDesc
              __typename
            }
            dollarOff
            percentageOff
            promotionTag
            savingsCenter
            savingsCenterPromos
            specialBuySavings
            specialBuyDollarOff
            specialBuyPercentageOff
            __typename
          }
          specialBuy
          unitOfMeasure
          value
          __typename
        }
      __typename
    }
    id
    templates
    discoveryZones @skip(if: $skipDiscoveryZones) {
      products(dataSource: $dataSource) {
        itemId
        dataSources
        badges(storeId: $storeId) {
          name
          __typename
        }
        info {
          isSponsored
          sponsoredMetadata {
            campaignId
            placementId
            slotId
            sponsoredId
            trackSource
            __typename
          }
          sponsoredBeacon {
            onClickBeacon
            onViewBeacon
            onClickBeacons
            onViewBeacons
            __typename
          }
          productSubType {
            name
            __typename
          }
          augmentedReality
          globalCustomConfigurator {
            customExperience
            __typename
          }
          swatches {
            isSelected
            itemId
            label
            swatchImgUrl
            url
            value
            __typename
          }
          totalNumberOfOptions
          hidePrice
          ecoRebate
          quantityLimit
          categoryHierarchy
          sskMin
          sskMax
          unitOfMeasureCoverage
          wasMaxPriceRange
          wasMinPriceRange
          __typename
        }
        identifiers {
          canonicalUrl
          productType
          productLabel
          modelNumber
          storeSkuNumber
          itemId
          brandName
          parentId
          __typename
        }
        media {
          images {
            url
            type
            subType
            sizes
            __typename
          }
          __typename
        }
        dataSource
        details {
          collection {
            name
            url
            __typename
          }
          __typename
        }
        taxonomy {
          breadCrumbs {
            label
            __typename
          }
          __typename
        }
        reviews {
          ratingsReviews {
            averageRating
            totalReviews
            __typename
          }
          __typename
        }
        __typename
      }
      metadata {
        zone
        zoneTitle
        __typename
      }
      __typename
    }
    partialTemplates
    dimensions {
      label
      refinements {
        refinementKey
        label
        recordCount
        selected
        imgUrl
        url
        nestedRefinements {
          label
          url
          recordCount
          refinementKey
          __typename
        }
        __typename
      }
      collapse
      dimensionId
      isVisualNav
      isVisualDimension
      isNumericFilter
      isColorSwatch
      nestedRefinementsLimit
      visualNavSequence
      __typename
    }
    appliedDimensions {
      label
      refinements {
        label
        refinementKey
        url
        __typename
      }
      isNumericFilter
      __typename
    }
    buyitagain(dataSource: $dataSource) @skip(if: $skipBuyitagain) {
      itemId
      dataSources
      badges(storeId: $storeId) {
        name
        __typename
      }
      info {
        isSponsored
        sponsoredMetadata {
          campaignId
          placementId
          slotId
          sponsoredId
          trackSource
          __typename
        }
        sponsoredBeacon {
          onClickBeacon
          onViewBeacon
          onClickBeacons
          onViewBeacons
          __typename
        }
        productSubType {
          name
          link
          __typename
        }
        augmentedReality
        globalCustomConfigurator {
          customExperience
          __typename
        }
        customerSignal {
          previouslyPurchased
          __typename
        }
        isBuryProduct
        isGenericProduct
        returnable
        hidePrice
        ecoRebate
        quantityLimit
        categoryHierarchy
        sskMin
        sskMax
        unitOfMeasureCoverage
        wasMaxPriceRange
        wasMinPriceRange
        __typename
      }
      identifiers {
        canonicalUrl
        productType
        productLabel
        modelNumber
        storeSkuNumber
        itemId
        brandName
        specialOrderSku
        __typename
      }
      media {
        images {
          url
          type
          subType
          sizes
          __typename
        }
        __typename
      }
      details {
        installation {
          serviceType
          __typename
        }
        collection {
          name
          url
          __typename
        }
        __typename
      }
      fulfillment(storeId: $storeId, zipCode: $zipCode) {
        anchorStoreStatus
        anchorStoreStatusType
        backordered
        backorderedShipDate
        bossExcludedShipStates
        excludedShipStates
        seasonStatusEligible
        fulfillmentOptions {
          type
          fulfillable
          services {
            deliveryTimeline
            deliveryDates {
              startDate
              endDate
              __typename
            }
            deliveryCharge
            dynamicEta {
              hours
              minutes
              __typename
            }
            hasFreeShipping
            freeDeliveryThreshold
            locations {
              curbsidePickupFlag
              isBuyInStoreCheckNearBy
              distance
              inventory {
                isOutOfStock
                isInStock
                isLimitedQuantity
                isUnavailable
                quantity
                maxAllowedBopisQty
                minAllowedBopisQty
                __typename
              }
              isAnchor
              locationId
              state
              storeName
              storePhone
              type
              __typename
            }
            type
            totalCharge
            __typename
          }
          __typename
        }
        onlineStoreStatus
        onlineStoreStatusType
        __typename
      }
      installServices(storeId: $storeId, zipCode: $zipCode)
        @skip(if: $skipInstallServices) {
        scheduleAMeasure
        gccCarpetDesignAndOrderEligible
        __typename
      }
      taxonomy {
        breadCrumbs {
          label
          __typename
        }
        __typename
      }
      pricing(storeId: $storeId) {
        alternatePriceDisplay
        alternate {
          bulk {
            pricePerUnit
            thresholdQuantity
            value
            __typename
          }
          unit {
            caseUnitOfMeasure
            unitsOriginalPrice
            unitsPerCase
            value
            __typename
          }
          __typename
        }
        original
        mapAboveOriginalPrice
        message
        preferredPriceFlag
        promotion {
          type
          description {
            shortDesc
            longDesc
            __typename
          }
          dollarOff
          percentageOff
          promotionTag
          savingsCenter
          savingsCenterPromos
          specialBuySavings
          specialBuyDollarOff
          specialBuyPercentageOff
          __typename
        }
        specialBuy
        unitOfMeasure
        value
        __typename
      }
      dataSource
      __typename
    }
    __typename
  }
}
`;

export const searchcollectionSkuesQueryByItemIds = `query searchModel($storeId: String, $zipCode: String, $skipInstallServices: Boolean = true, $skipKPF: Boolean = false, $skipSpecificationGroup: Boolean = false, $skipSubscribeAndSave: Boolean = false, $itemIds: [String]\u0021) { 
  searchModel(itemIds: $itemIds) { 
    products { itemId availabilityType { discontinued type __typename } badges(storeId: $storeId) { name __typename } 
    details { collection { collectionId name url __typename } highlights __typename } favoriteDetail { count __typename } fulfillment(storeId: $storeId, zipCode: $zipCode) { backordered backorderedShipDate bossExcludedShipStates excludedShipStates seasonStatusEligible fulfillmentOptions { type fulfillable services { type hasFreeShipping freeDeliveryThreshold locations { curbsidePickupFlag isBuyInStoreCheckNearBy distance inventory { isOutOfStock isInStock isLimitedQuantity isUnavailable quantity maxAllowedBopisQty minAllowedBopisQty __typename } isAnchor locationId storeName state type __typename } __typename } __typename } __typename } 
    identifiers { brandName canonicalUrl modelNumber productType productLabel itemId storeSkuNumber parentId isSuperSku __typename } 
    info { hasSubscription isBuryProduct isSponsored isGenericProduct isLiveGoodsProduct sponsoredBeacon { onClickBeacon onViewBeacon __typename } 
    sponsoredMetadata { campaignId placementId slotId __typename } globalCustomConfigurator { customExperience __typename } returnable hidePrice productSubType { name link __typename } 
    categoryHierarchy samplesAvailable customerSignal { previouslyPurchased __typename } productDepartmentId productDepartment augmentedReality ecoRebate quantityLimit sskMin sskMax unitOfMeasureCoverage wasMaxPriceRange wasMinPriceRange swatches { isSelected itemId label swatchImgUrl url value __typename } totalNumberOfOptions paintBrand dotComColorEligible __typename } 
    installServices(storeId: $storeId, zipCode: $zipCode) @skip(if: $skipInstallServices) { scheduleAMeasure gccCarpetDesignAndOrderEligible __typename } media { images { url type subType sizes __typename } __typename } reviews { ratingsReviews { averageRating totalReviews __typename } __typename } 
    dataSources pricing(storeId: $storeId) { value alternatePriceDisplay alternate { bulk { pricePerUnit thresholdQuantity value __typename } unit { caseUnitOfMeasure unitsOriginalPrice unitsPerCase value __typename } __typename } 
    original mapAboveOriginalPrice message preferredPriceFlag promotion { type description { shortDesc longDesc __typename } dollarOff percentageOff promotionTag savingsCenter savingsCenterPromos specialBuySavings specialBuyDollarOff specialBuyPercentageOff dates { start end __typename } __typename } specialBuy unitOfMeasure __typename } 
    keyProductFeatures @skip(if: $skipKPF) { keyProductFeaturesItems { features { name refinementId refinementUrl value __typename } __typename } __typename } 
    keyProductFeatures @skip(if: $skipKPF) { keyProductFeaturesItems { features { name refinementId refinementUrl value __typename } __typename } __typename } specificationGroup @skip(if: $skipSpecificationGroup) { specifications { specName specValue __typename } specTitle __typename } 
    subscription @skip(if: $skipSubscribeAndSave) { defaultfrequency discountPercentage subscriptionEnabled __typename } sizeAndFitDetail { attributeGroups { attributes { attributeName dimensions __typename } dimensionLabel productType __typename } __typename } __typename } __typename }}`;

export const metadataQuery = `query metadata($parentId: String\u0021) { metadata(parentId: $parentId) { 
attributes { attributeValues { value swatchGuid __typename } attributeName isSwatch __typename } childItemsLookup { itemId attributeCombination canonicalUrl isItemBackOrdered __typename } 
superDuperSku { attributes { attributeName attributeValues { selected superSkuUrl value __typename } __typename } __typename } __typename }}`;
